export class DocumentFilterModel {
  constructor(obj) {
    this.keyword = '';
    this.pageRange = { pageStart: '', pageEnd: '' };
    this.hasProducts = '';    
  }

  if (obj) {
    Object.assign(this, obj);
  }

}